import { createSlice } from '@reduxjs/toolkit';

// Same pattern as the main app's authSlice.js: the httpOnly `agencyJwt`
// cookie is the actual credential and is never touched from JS — this
// slice just remembers who is logged in (from the login response body) so
// the UI can render a name/tier and PrivateRoute can decide whether to
// redirect to /login, without waiting on a network round-trip.
const initialState = {
  agencyInfo: localStorage.getItem('agencyInfo')
    ? JSON.parse(localStorage.getItem('agencyInfo'))
    : null,
};

const authSlice = createSlice({
  name: 'agencyAuth',
  initialState,
  reducers: {
    setAgencyCredentials: (state, action) => {
      state.agencyInfo = action.payload;
      localStorage.setItem('agencyInfo', JSON.stringify(action.payload));
    },
    agencyLogout: (state) => {
      state.agencyInfo = null;
      localStorage.removeItem('agencyInfo');
    },
  },
});

export const { setAgencyCredentials, agencyLogout } = authSlice.actions;
export default authSlice.reducer;
